export default class Product {

    constructor(id, title, description, price, cards, media){
        this.id = id;
        this.title = title;
        this.description = description;
        this.price = price;
        this.cards = cards;
        this.media = media;
        this.isAddedToCart = false;
    }

    getId(){
        return this.id;
    }

    getTitle(){
        return this.title;
    }

    getDescription(){
        return this.description;
    }

    getPrice(){
        return this.price;
    }

    getCards(){
        return this.cards;
    }

    getMedia(){
        return this.media;
    }

    setId(id){
        this.id = id;
    }

    setTitle(title){
        this.title = title;
    }

    setDescription(description){
        this.description = description;
    }

    setPrice(price){
        this.price = price;
    }

    setCards(cards){
        this.cards = cards;
    }
    
    setMedia(media){
        this.media = media;
    }
}